import numeral from 'numeral';

export function amountFormat(value: any) {
  const amount = numeral(value).format('0,0.00');
  return `$${amount}`;
}
